export const getAffiliationCaption = (values?: {
	hcoType?: string;
	location?: string;
}): string | undefined => {
	const type = values?.hcoType?.toString().trim();
	const location = values?.location?.toString().trim();

	return [type, location].filter(Boolean).join(' · ') || undefined;
};
